import { render, staticRenderFns } from "./calendarItem.vue?vue&type=template&id=843094be&scoped=true&"
import script from "./calendarItem.vue?vue&type=script&lang=js&"
export * from "./calendarItem.vue?vue&type=script&lang=js&"
import style0 from "./calendarItem.vue?vue&type=style&index=0&id=843094be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843094be",
  null
  
)

export default component.exports